import { render } from "./SupportOld2024List.vue?vue&type=template&id=85578f36&scoped=true"
import script from "./SupportOld2024List.vue?vue&type=script&lang=js"
export * from "./SupportOld2024List.vue?vue&type=script&lang=js"

import "./SupportOld2024List.vue?vue&type=style&index=0&id=85578f36&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85578f36"]])

export default __exports__